import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Featureful - Premium Roadmap Template</h1>
        <p>Introducing Featureful - the premium Framer template built to help you easily & beautifully showcase the roadmap for your website or app.</p>
      </header>
      
      <main className="App-main">
        <section className="hero-section">
          <h2>Bem-vindo ao Academy</h2>
          <p>Este é um sistema React básico que renderiza o conteúdo do site original.</p>
        </section>
        
        <section className="content-section">
          <h3>Recursos Principais</h3>
          <ul>
            <li>Interface moderna e responsiva</li>
            <li>Componentes React reutilizáveis</li>
            <li>Estrutura organizada e escalável</li>
            <li>Fácil manutenção e atualização</li>
          </ul>
        </section>
        
        <section className="cta-section">
          <h3>Comece Agora</h3>
          <button className="cta-button">
            Explorar Recursos
          </button>
        </section>
      </main>
      
      <footer className="App-footer">
        <p>&copy; 2024 Academy. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
}

export default App;
